var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "uni-course-subject" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 10 } },
        [
          _c("el-col", { attrs: { span: 18 } }, [
            _c(
              "div",
              {
                staticClass: "top-box subject-study",
                staticStyle: { height: "240px" },
              },
              [
                _c(
                  "div",
                  { staticClass: "img-box" },
                  [
                    _vm.datas.thumb
                      ? _c("el-image", {
                          staticClass: "img",
                          attrs: { src: _vm.datas.thumb, fit: "contain" },
                        })
                      : _c("el-image", {
                          staticClass: "img",
                          attrs: {
                            src: require("@/views/business/course/image/mycourse.jpg"),
                            fit: "contain",
                          },
                        }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "info-box" },
                  [
                    _c("h1", { staticClass: "title" }, [
                      _c("span", { staticClass: "span1" }, [
                        _vm._v("当前课程："),
                      ]),
                      _vm._v(" " + _vm._s(_vm.datas.title) + " "),
                      _c("span", { staticClass: "span2" }, [
                        _vm._v("(" + _vm._s(_vm.datas.credit) + "学分)"),
                      ]),
                    ]),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      _vm._l(_vm.subData, function (item, key) {
                        return _c(
                          "el-col",
                          {
                            key: key,
                            attrs: {
                              span: item.title === "学习总时长" ? 10 : 7,
                            },
                          },
                          [
                            _vm.courseType == 2 ||
                            (_vm.courseType != 2 && key != "work")
                              ? _c("ComponentCircleProgress", {
                                  attrs: {
                                    color: _vm.subDataColor[key],
                                    datas: item,
                                    progressWidth: 100,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c(
              "div",
              {
                staticClass: "top-box subject-note",
                staticStyle: { height: "240px" },
              },
              [
                _c("div", { staticClass: "uni-link-title" }, [
                  _c("h3", [
                    _c("span", { staticClass: "bold" }, [_vm._v("课程说明")]),
                    _c("i", { staticClass: "iconfont iconicon-test" }),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "note-list" },
                  [
                    _vm.datas.explain
                      ? _c("div", {
                          staticClass: "note-desc",
                          domProps: { innerHTML: _vm._s(_vm.datas.explain) },
                        })
                      : _c("ComponentEmpty", {
                          staticStyle: { padding: "0" },
                          attrs: {
                            imgClass: "img-size",
                            title: "暂无课程说明",
                            tips: "",
                          },
                        }),
                    _c("div", { staticStyle: { "text-align": "right" } }, [
                      _vm.datas.explain
                        ? _c(
                            "span",
                            {
                              staticClass: "gray-link mat10",
                              on: { click: _vm.noteMore },
                            },
                            [_vm._v("查看更多")]
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ],
        1
      ),
      _vm.datas.courseware
        ? _c("div", { staticClass: "online" }, [
            _c("div", { staticClass: "onlineName" }, [
              _vm.fileName === "pdf"
                ? _c("img", {
                    staticClass: "onlineNameImg",
                    attrs: {
                      src: require("../../../assets/images/PDF.svg"),
                      alt: "",
                    },
                  })
                : _vm.fileName === "docx"
                ? _c("img", {
                    staticClass: "onlineNameImg",
                    attrs: {
                      src: require("../../../assets/images/word.svg"),
                      alt: "",
                    },
                  })
                : _c("img", {
                    staticClass: "onlineNameImg",
                    attrs: {
                      src: require("../../../assets/images/courseware.svg"),
                      alt: "",
                    },
                  }),
              _c("p", [
                _vm._v(" 课程名称："),
                _c("span", [_vm._v(_vm._s(_vm.datas.title))]),
              ]),
            ]),
            _c(
              "a",
              { attrs: { href: _vm.datas.courseware, target: "_blank" } },
              [_vm._m(0)]
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "bottom-box mat20" },
        [
          _c("ComponentCollapse", {
            ref: "componentCollapse",
            attrs: {
              dataObj: _vm.datas,
              activeNamesList: _vm.collapseData,
              activeNames: _vm.activeNames,
              isAllowed: _vm.isAllowed,
            },
          }),
          _vm.collapseData.length == 0
            ? _c("ComponentEmpty", {
                attrs: { tips: "", title: "暂无课程列表" },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "课程说明",
            visible: _vm.noteMoreVisible,
            top: "30vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.noteMoreVisible = $event
            },
          },
        },
        [
          _c("div", {
            staticClass: "note-modal",
            domProps: { innerHTML: _vm._s(_vm.datas.explain) },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "onlineButton" }, [
      _c("em"),
      _c("span", [_vm._v("课件下载")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }